export function versionRef(v: number | string): string {
  return `ref#${v}. `;
}
